// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.


import { CustomEvent } from "../../Utils/CustomEvents.js";
import { Resources } from "../../Commons/properties/Resources.js";
import { MainWindowManager } from "../UtilsClasses/MainWindowManager.js";
import { PropertySetupScreenTemplate } from "../../templates.js";
import { QuickTreeNode } from "../elements/QuickTree/QuickTreeNode.js";
import { TerceraQuickTree } from "../elements/QuickTree/TerceraQuickTree.js";
import { TerceraButton } from "../elements/TerceraButton.js";
import { DynProperty } from "../../Commons/DynProperty.js";
import { PropertySetupScreen } from "./PropertySetupScreen.js";

export let ASPConnectionManagerScreen = PropertySetupScreen.extend({
    data: function ()
    {
        return {
        };
    },
    partials: { bodyPartial: PropertySetupScreenTemplate }
});

ASPConnectionManagerScreen.prototype.getType = function () { return 'ASPConnectionManagerScreen'; };

ASPConnectionManagerScreen.show = function (caller, headerKey, callback)
{
    var scr = new ASPConnectionManagerScreen();
    MainWindowManager.MainWindow.addControl(scr);
    scr.set({
        callback: caller.callBackConnections.bind(caller),
        name: scr._guid,
        header: Resources.getResource(headerKey),
        focused: true,
    });
    scr.caller = caller;
}

ASPConnectionManagerScreen.prototype.FillTree = function ()
{
    this.caller;
    var qTree = this.qTree.quickTree;

    qTree.SelectionChanged.Subscribe(this.seletionChange, this);

    var cons = this.caller.connectionSettings.connections.connection;
    if (Array.isArray(cons))
    {
        var i;
        var len = cons.length;
        for (i = 0; i < len; i++)
        {
            var props = DynProperty.deserialize(cons[i].properties);

            var cData = new ConnectionData();
            cData.callBack(props);

            var cNode = new QuickTreeNode(cData.name);
            cNode.tag = cData.Properties();
            qTree.AddNode(cNode)
        }
    }
    else
    {
        var props = DynProperty.deserialize(cons.properties);

        var cData = new ConnectionData();
        cData.callBack(props);

        var cNode = new QuickTreeNode(name);
        cNode.tag = cData.Properties();
        qTree.AddNode(cNode)
    }

    var tmp = qTree.nodeCollection.length;
    if (tmp > 0)
        qTree.setSelectedNode(qTree.nodeCollection[tmp - 1]);
}

ASPConnectionManagerScreen.prototype.oncomplete = function ()
{
    PropertySetupScreen.prototype.oncomplete.apply(this);
    this.qTree = new TerceraQuickTree();
    this.Controls.leftPanel.addControl(this.qTree);
    this.qTree.setBounds(0, 0, 200, 350);
    this.Controls.leftPanel.el.style.height = "350px";


    var btnAdd = new TerceraButton();
    btnAdd.setBounds(12, 370, 95, 25);
    btnAdd.set({ name: 'Add', text: 'Add' });
    var AddEvent = new CustomEvent();
    AddEvent.Subscribe(this.addClick, this);
    btnAdd.onClick = AddEvent;

    var btnRem = new TerceraButton();
    btnRem.setBounds(115, 370, 95, 25);
    btnRem.set({ name: 'Remove', text: 'Remove' });
    var RemEvent = new CustomEvent();
    RemEvent.Subscribe(this.removeClick, this);
    btnRem.onClick = RemEvent;
    this.addControl(btnAdd);
    this.addControl(btnRem);

    this.FillTree();
};

ASPConnectionManagerScreen.prototype.seletionChange = function ()
{
    if (this.qTree.quickTree.selectedNode)
    {
        this.arrayProperties = this.qTree.quickTree.selectedNode.tag;
        this.FillGrid(this.arrayProperties);
    }
};

ASPConnectionManagerScreen.prototype.addClick = function ()
{
    var qTree = this.qTree.quickTree;
    var cData = new ConnectionData();
    cData.name = "New " + qTree.nodeCollection.length;

    var cNode = new QuickTreeNode(cData.name);
    cNode.tag = cData.Properties();
    qTree.AddNode(cNode);
    qTree.setSelectedNode(qTree.nodeCollection[qTree.nodeCollection.length - 1]);
}
ASPConnectionManagerScreen.prototype.removeClick = function ()
{
    var qTree = this.qTree.quickTree;
    if (qTree.selectedNode)
    {
        var index = qTree.nodeCollection.indexOf(qTree.selectedNode);
        if (index !== -1)
            qTree.RemoveNode(index);
        if (qTree.nodeCollection.length > 0)
            qTree.setSelectedNode(qTree.nodeCollection[0]);
    }
}

ASPConnectionManagerScreen.prototype.okClick = function ()
{
    var callback = this.get('callback');
    if (callback)
    {
        var result = {};
        result.connections = {};
        result.connections.connection = [];
        var qTree = this.qTree.quickTree;
        var i;
        var len = qTree.nodeCollection.length;
        for (i = 0; i < len; i++)
        {
            var connection = {};
            connection.properties = DynProperty.serialize(qTree.nodeCollection[i].tag)
            result.connections.connection.push(connection);
        }
        callback(result);
    }
    this.close();
};


export let ConnectionData = function ()
{
    this.name = null;
    this.vendor = "PFix";

    this.type = "demo";

    this.serverAddress = null;
    this.useSSL = false;

    this.registrationMode = ConnectionData.RegistrationMode.Screen;
    this.customRegistrationLink = null;
};

ConnectionData.prototype.Properties = function ()
{
    var properties = [];
    properties.push(new DynProperty("name", this.name, DynProperty.STRING, DynProperty.CONNECTION_SUBGROUP));

    var dp = new DynProperty("vendor", this.vendor, DynProperty.COMBOBOX_COMBOITEM, DynProperty.CONNECTION_SUBGROUP);
    properties.push(dp);
    dp.objectVariants = [
        { value: "PFix", text: "PFix" },
        { value: "FXCM", text: "FXCM" },
        { value: "Oanda", text: "Oanda" },
        { value: "LMAX", text: "LMAX" }
    ];
    dp.assignedProperty = ['registrationMode', 'customRegistrationLink'];
    dp.COMBOBOX_TYPE = DynProperty.STRING;

    var vendorDP = dp;

    // TODO.
    dp = new DynProperty("type", this.type, DynProperty.COMBOBOX_COMBOITEM, DynProperty.CONNECTION_SUBGROUP);
    dp.objectVariants = [
        { value: "demo", text: "demo" },
        { value: "live", text: "live" }
    ];
    dp.COMBOBOX_TYPE = DynProperty.STRING;
    properties.push(dp);

    dp = new DynProperty("registrationMode", this.registrationMode, DynProperty.COMBOBOX_COMBOITEM, DynProperty.CONNECTION_SUBGROUP);;
    dp.objectVariants = [
        { text: "Blocked", value: ConnectionData.RegistrationMode.Blocked },
        { text: "Link", value: ConnectionData.RegistrationMode.Link },
        { text: "Screen", value: ConnectionData.RegistrationMode.Screen }
    ];
    dp.COMBOBOX_TYPE = DynProperty.INTEGER;
    dp.enabilityValue = 'PFix';
    dp.enabled = vendorDP.value === 'PFix';
    properties.push(dp);

    dp = new DynProperty("customRegistrationLink", this.customRegistrationLink, DynProperty.STRING, DynProperty.CONNECTION_SUBGROUP);
    dp.enabilityValue = 'PFix';
    dp.enabled = vendorDP.value === 'PFix';
    properties.push(dp);

    properties.push(new DynProperty("serverAddress", this.serverAddress, DynProperty.STRING, DynProperty.CONNECTION_SUBGROUP));
    properties.push(new DynProperty("useSSL", this.useSSL, DynProperty.BOOLEAN, DynProperty.CONNECTION_SUBGROUP));

    return properties;
};

ConnectionData.prototype.callBack = function (properties)
{
    var dp = DynProperty.getPropertyByName(properties, "name");
    if (DynProperty.isCorrect(dp))
        this.name = dp.value;
    var dp = DynProperty.getPropertyByName(properties, "vendor");
    if (DynProperty.isCorrect(dp))
        this.vendor = dp.value;
    var dp = DynProperty.getPropertyByName(properties, "type");
    if (DynProperty.isCorrect(dp))
        this.type = dp.value;
    var dp = DynProperty.getPropertyByName(properties, "serverAddress");
    if (DynProperty.isCorrect(dp))
        this.serverAddress = dp.value;
    var dp = DynProperty.getPropertyByName(properties, "useSSL");
    if (DynProperty.isCorrect(dp))
        this.useSSL = dp.value;
    var dp = DynProperty.getPropertyByName(properties, "registrationMode");
    if (DynProperty.isCorrect(dp))
    {
        // TODO.
        this.registrationMode = parseInt(dp.value);
    }
    var dp = DynProperty.getPropertyByName(properties, "customRegistrationLink");
    if (DynProperty.isCorrect(dp))
        this.customRegistrationLink = dp.value;
};

ConnectionData.RegistrationMode = { Blocked: 0, Screen: 1, Link: 2 };